import { useCallback, useRef } from "react";
import { driver } from "driver.js";
import { setActiveDriver, clearActiveDriver } from "./driverRegistry";

export default function useGameListDomainsTour() {
    const driverRef = useRef(null);

    const startTour = useCallback((_opts = {}) => {
        if (driverRef.current) {
            try { driverRef.current.destroy(); } catch (_) { /* noop */ }
        }

        const driverObj = driver({
            showProgress: true,
            animate: true,
            overlayColor: "rgba(0,0,0,0.55)",
            stagePadding: 8,
            stageRadius: 12,
            allowClose: false,
            steps: [
                {
                    element: "#tour-domains-heading",
                    popover: {
                        title: "Domain Explorer",
                        description: "Here you can explore analytics challenges grouped by industry domain like HR, Finance, Healthcare, and more.",
                        side: "bottom",
                        align: "start",
                    },
                },
                {
                    element: "#tour-domains-carousel",
                    popover: {
                        title: "Browse Domains",
                        description: "Swipe or use the arrows below to browse through available domains. Each card represents a different industry.",
                        side: "left",
                        align: "center",
                    },
                },
                {
                    element: '[data-tour-id="tour-domains-prev"]',
                    popover: {
                        title: "Navigate Back",
                        description: "Use this arrow to go to the previous domain card.",
                        side: "top",
                        align: "center",
                        showButtons: ["previous", "close"],
                    },
                },
                {
                    element: '[data-tour-id="tour-domains-next"]',
                    popover: {
                        title: "Navigate Forward",
                        description: "Use this arrow to move to the next domain card.",
                        side: "top",
                        align: "center",
                        showButtons: ["previous", "close"],
                    },
                },
                {
                    element: "#tour-domain-details",
                    popover: {
                        title: "Domain Details",
                        description: "This panel shows details about the current domain — its description, number of problems, and total XP available.",
                        side: "left",
                        align: "center",
                    },
                },
                {
                    element: '.swiper-slide-active [data-tour-id="tour-domain-explore"]',
                    popover: {
                        title: "Explore a Domain",
                        description: "Click the EXPLORE button to see all the challenges available in this domain. Go ahead and click it!",
                        side: "bottom",
                        align: "center",
                        showButtons: ["close"],
                    },
                },
            ],
        });

        driverRef.current = driverObj;
        setActiveDriver(driverObj);

        driverObj.onDestroyFinished = () => {
            clearActiveDriver();
        };
        driverObj.drive();
    }, []);

    return startTour;
}
